export default "__VITE_ASSET__B$Nw7yGp__"